module.exports = __webpack_public_path__ + "img/Menu-01.81ce8880.png";